export default __webpack_public_path__ + "static/Biases-19a227467c49b2ecbfbfad85801abdae.png";